import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TranslationLoadingContextType {
	isTranslating: boolean;
	setIsTranslating: (loading: boolean) => void;
}

const TranslationLoadingContext = createContext<TranslationLoadingContextType | undefined>(undefined);

export function TranslationLoadingProvider({ children }: { children: ReactNode }) {
	const [isTranslating, setIsTranslating] = useState(false);

	return (
		<TranslationLoadingContext.Provider value={{ isTranslating, setIsTranslating }}>
			{children}
			{isTranslating && (
				<div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
					<div className="flex flex-col items-center gap-4">
						<div className="h-16 w-16 animate-spin rounded-full border-4 border-white border-t-transparent"></div>
						<p className="text-white text-lg font-medium">처리중</p>
					</div>
				</div>
			)}
		</TranslationLoadingContext.Provider>
	);
}

export function useTranslationLoadingContext() {
	const context = useContext(TranslationLoadingContext);
	if (!context) {
		throw new Error('useTranslationLoadingContext must be used within TranslationLoadingProvider');
	}
	return context;
}
